<template><div><p class="d-mbs-400">
  <a
    href="https://github.com/dialpad/dialtone/"
  >
    <img
      alt="Dialtone version number"
      src="https://img.shields.io/github/package-json/v/dialpad/dialtone?color=D3BCFF&label=Dialtone"
    />
  </a>
</p>
<div class="d-mbe-200">
  <dialtone-changelog />
</div>
<p class="d-docsite--paragraph">View <a href="https://github.com/dialpad/dialtone/releases" class="d-docsite--link d-link" target="_blank" rel="noopener noreferrer">all releases</a> on GitHub.</p>
</div></template>


<script setup>
  import DialtoneChangelog from '@views/DialtoneChangelog.vue';
</script>